UISubscribeMessage = xClass("UISubscribeMessage", cc.Node)

UISubscribeMessage.resList = [
    "cocos/panel_adprompt.plist"
]
UISubscribeMessage.preload = function () {
    return preloadWithLoadingPromise(UISubscribeMessage.resList, false);
}
UISubscribeMessage.create = function(
    msgId, 
    hintStr, 
    hintStrColor, 
    selected, 
    autoSubmsg,
    showSelectbox,
    showBack,
    submsgSuccessHint,
    submsgFailHint,
    fontSize
    ){
    let msg = UISubscribeMessage.new(
        msgId, 
        hintStr, 
        hintStrColor, 
        selected, 
        autoSubmsg, 
        showSelectbox,
        showBack,
        submsgSuccessHint,
        submsgFailHint,
        fontSize
        )
    return msg
}
UISubscribeMessage.getModuleId = function(msgId){
    var moduleId
    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        if (msgId == "uQ6E7ML6iyiuX5pwN1JKdsvYIOJeHzwYHYMmuJ-P_MM"){
            moduleId = "subscription_mark"
        }else if (msgId == "7fLAQ_U3xPADadSDclPtFCQx2GmTA-7JFnXYj183wTg"){
            moduleId = "subscription_energy"
        }else if (msgId == "BCDiHiXxf6ZRttDNmUh36X8WsX6CfCDDJ023KocBMgo"){
            moduleId = "subscription_level"
        }else if (msgId == "ccYFNfk1DhFY3rYcOsqxNQ_gWYfDcbQkYOBqK_6wcNQ"){
            moduleId = "subscription_pvp"
        }else if (msgId == "AgQytwJv3t5w3SaA9rQKmtLBFUcxWs076Uzrl3UzHBM"){
            moduleId = "subscription_newchest"
        }else if (msgId == "1wGgiFon7QoVBLjCE7dFXMzq6W2rzRTa8Ol_b1bb1Dk") {
            moduleId = "subscription_island_ad"
        }else if (msgId == "M3iOi4n1F_T7dEoybTFlqK6iVEAPdS45KJN_k8ylS0c") {
            moduleId = "subscription_island_timeup"
        }else if (msgId == "n_CunfuAN_6uqmF9viA5QuF_aj16oR-wHWpHb7MISTk") {
            moduleId = "subscription_ad_gamble"
        }
    }else if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame && META.specialPFInQQlightgame != "wanba_ts") {
        if (msgId == "092652a52796c7fa6b89f577a2804ed5"){
            moduleId = "subscription_mark"
        }else if (msgId == "47a3929065e2b412ec5bf738b8628a89"){
            moduleId = "subscription_energy"
        }else if (msgId == "65a2c6a846a2bdc56adf48935098e638"){
            moduleId = "subscription_level"
        }else if (msgId == "72cb3d610cc4f1d2e1154c71d607a004"){
            moduleId = "subscription_pvp"
        }else if (msgId == "b484750324b41e4a149e72e4c6fb52fd"){
            moduleId = "subscription_newchest"
        }else if (msgId == "650177f25603db9fb9d567a2da652b78") {
            moduleId = "subscription_island_ad"
        }else if (msgId == "9a2db2e7b676829b01edd750f5d39c72") {
            moduleId = "subscription_island_timeup"
        }else if (msgId == "378bff46d5592b03b372ef436279c718") {
            moduleId = "subscription_ad_gamble"
        }
    }
    return moduleId
}
UISubscribeMessage.getDcId = function(msgId){
    var dcId
    if (window.mini && mini.getPlatform() == MiniPlatform.wechatGame) {
        if (msgId == "uQ6E7ML6iyiuX5pwN1JKdsvYIOJeHzwYHYMmuJ-P_MM"){
            dcId = "mark"
        }else if (msgId == "7fLAQ_U3xPADadSDclPtFCQx2GmTA-7JFnXYj183wTg"){
            dcId = "energy"
        }else if (msgId == "BCDiHiXxf6ZRttDNmUh36X8WsX6CfCDDJ023KocBMgo"){
            dcId = "level"
        }else if (msgId == "ccYFNfk1DhFY3rYcOsqxNQ_gWYfDcbQkYOBqK_6wcNQ"){
            dcId = "pvp"
        }else if (msgId == "AgQytwJv3t5w3SaA9rQKmtLBFUcxWs076Uzrl3UzHBM"){
            dcId = "newchest"
        }else if (msgId == "1wGgiFon7QoVBLjCE7dFXMzq6W2rzRTa8Ol_b1bb1Dk"){
            dcId = "island_unlock"
        }else if (msgId == "M3iOi4n1F_T7dEoybTFlqK6iVEAPdS45KJN_k8ylS0c"){
            dcId = "island_unlock"
        }else if (msgId == "n_CunfuAN_6uqmF9viA5QuF_aj16oR-wHWpHb7MISTk") {
            dcId = "ad_gacha"
        }
    }else if (window.mini && mini.getPlatform() == MiniPlatform.qqlightGame) {
        if (msgId == "092652a52796c7fa6b89f577a2804ed5"){
            dcId = "mark"
        }else if (msgId == "47a3929065e2b412ec5bf738b8628a89"){
            dcId = "energy"
        }else if (msgId == "65a2c6a846a2bdc56adf48935098e638"){
            dcId = "level"
        }else if (msgId == "72cb3d610cc4f1d2e1154c71d607a004"){
            dcId = "pvp"
        }else if (msgId == "b484750324b41e4a149e72e4c6fb52fd"){
            dcId = "newchest"
        }else if (msgId == "650177f25603db9fb9d567a2da652b78"){
            dcId = "island_unlock"
        }else if (msgId == "9a2db2e7b676829b01edd750f5d39c72"){
            dcId = "island_unlock"
        }else if (msgId == "378bff46d5592b03b372ef436279c718") {
            dcId = "ad_gacha"
        }
    }
    return dcId
}
UISubscribeMessage.prototype.ctor = function (
    msgId, 
    hintStr, 
    hintStrColor, 
    selected, 
    autoSubmsg, 
    showSelectbox,
    showBack,
    submsgSuccessHint,
    submsgFailHint,
    fontSize) {
    let self = this
    
    self.submsgSuccessHint = submsgSuccessHint
    self.submsgFailHint = submsgFailHint
    cc.Node.prototype.ctor.call(self)
    
    if (showSelectbox)
        self.checkBox = ccui.CheckBox.create(
            "panel_adprompt/checkmark_bg.png", 
            "panel_adprompt/checkmark_bg.png", 
            "panel_adprompt/checkmark_on.png", 
            "panel_adprompt/checkmark_on.png", 
            null, 
            ccui.Widget.PLIST_TEXTURE
            )
    else
        self.checkBox = ccui.CheckBox.create("", "", "", "", null, ccui.Widget.PLIST_TEXTURE)
    
    self.checkBox.setPosition(0, 0)
    self.checkBox.setAnchorPoint(0.5,0.5)
    //self.checkBox.setLocalZOrder(11)
    self.autoSubmsg = autoSubmsg
    self.showSelectbox = showSelectbox
    if (autoSubmsg)
        self.checkBox.addEventListener(throttle(self.onSelectChange, 100), self)
    self.checkBox.setSelected(selected)
    self.checkBox.setVisible(showSelectbox)
    self.addChild(self.checkBox)
    self.msgId = msgId
    if (hintStr){
        self.msgLabel = cc.Label.createWithSystemFont(hintStr, FONT_DEF.microsoftYahei_22_noStroke)
        if (fontSize)
            self.msgLabel.setFontSize(fontSize)
        //self.msgLabel = cc.Label.createWithSystemFont(hintStr, "Microsoft YaHei", fontSize)
        self.msgLabel.setFontFillColor(hintStrColor)
        self.msgLabel.setAnchorPoint(0.0, 0.5)
        let yOffset = -2.0
        let env = mini.getSystemInfoSync();
        if (env.platform === "ios"){
            yOffset = -7.0
        }
        self.msgLabel.setPosition(30, yOffset)
        let size = self.msgLabel.getContentSize()
        self.setContentSize(cc.size(size.width+40, size.height))
        quickBuildBtn(self, UIButton, null, handler(self, self.onLabelClick))
        //产品又说不需要下划线了
        /*if (!showSelectbox)
        {
            //create underline
            var underline = cc.DrawNode.create()
            underline.setAnchorPoint(0, 0)
            underline.setPosition(0, -2)
            if (underline.setLineWidth) {
                underline.setLineWidth(1)
            }
            underline.color = hintStrColor
            var selfSize = self.getContentSize()
            var halfSelfHeight = selfSize.height * 0.5
            underline.drawRect(cc.p(30, -halfSelfHeight), cc.p(selfSize.width-10, 3-halfSelfHeight), underline.color)
            self.addChild(underline)
        }*/
        
        //泡泡底边
        if (showBack){
            var bubble = ccui.Scale9Sprite.createWithSpriteFrameName("uilibrary/bagTipBg.png")
            self.addChild(bubble)
            bubble.setContentSize(cc.size(size.width+30, size.height+20))
            bubble.setAnchorPoint(cc.p(0, 0))
            bubble.setPosition(15, -size.height/2-10)
            //var arrow = cc.Sprite.createWithSpriteFrameName("uilibrary/boxTipTail.png")
            //arrow.setAnchorPoint(0.5, 0)
            //arrow.setPosition(size.width / 3, size.height-12)
            //arrow.setFlippedY(true)
            //self.addChild(arrow)
        }

        self.addChild(self.msgLabel)
    }
    self.setLocalZOrder(100)
}
UISubscribeMessage.prototype.onSelectChange = function(){
    let self = this
    //console.log("@@@@on select changed:"+self.checkBox.isSelected())
    if (self.checkBox.isSelected()){
        self.dispatchEvent({
            name: "submsg_select"
        })
        //self.trySubscribeMsg()
    }
}
UISubscribeMessage.prototype.onLabelClick = function(){
    let self = this

    let selected = !self.checkBox.isSelected()
    if (!self.showSelectbox)
        selected = true
    self.checkBox.setSelected(selected)
    if (self.autoSubmsg)
        self.onSelectChange()
}
UISubscribeMessage.prototype.trySubscribeMsg = function(sendMsg, callback, isShowTip = true){
    let self =  this

    if (self.checkBox.isSelected()){
        DCAssist.userTrack("subscription","subscription_enter",{type:UISubscribeMessage.getDcId(self.msgId)})
        mini.requestSubscribeMessage({
            tmplIds:[self.msgId],
            success:(res)=>{
                console.log("@@@@subscribe msg success:"+JSON.stringify(res))
                
                if (res && res[self.msgId] == 'accept'){
                    DCAssist.userTrack("subscription","subscription_result",{type:UISubscribeMessage.getDcId(self.msgId), open:1})
                    if (sendMsg){
                        var http = subscribeMessageHttp.new()
                        http.addEventListener(Events.kComplete, ()=>{console.log("@@@@sub msg success")})
                        http.addEventListener(Events.kError, ()=>{console.log("@@@@sub msg failed")})
                        //http.addEventListener(Events.kCancel, onCancel)
                        http.load({module:UISubscribeMessage.getModuleId(self.msgId)})
                    }
                    if (isShowTip) Toast.make(self.submsgSuccessHint)
                    if (typeof(callback) == 'function'){
                        callback(true)
                    }
                }else{
                    Toast.make(self.submsgFailHint)
                    if (typeof(callback) == 'function'){
                        callback(false)
                    }
                    DCAssist.userTrack("subscription","subscription_result",{type:UISubscribeMessage.getDcId(self.msgId), open:0})
                }
            },
            fail:(res)=>{
                if (res && res.errCode == 20004){
                    Toast.make(getText("ad_gamble_subscribe_fail2"));
                }else{
                    Toast.make(self.submsgFailHint)
                }
                console.log("@@@@subscribe msg failed:"+JSON.stringify(res))
            }
        })
    }
}
UISubscribeMessage.prototype.cleanUp =  function(){
    ResManager.release(UISubscribeMessage.resList)
}
UISubscribeMessage.prototype.getSelected = function(){
    var self = this
    return self.checkBox.isSelected()
}
UISubscribeMessage.prototype.getWidth = function(){
    var self = this
    let width = 30
    width = width + self.getContentSize().width
    return width
}
module.exports = UISubscribeMessage